import { last } from 'rxjs';
import { Component, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldWrapper } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import { AppConstants } from 'src/app/providers/constants/app-constants.service';
import { Capacitor } from '@capacitor/core';
import { LhStorageService } from '@hssa-itasia/ngx-util-core';
import { BogTourService } from '../services/bog-tour/bog-tour.service';
import { AppService } from '../app.service';
@Component({
  selector: 'shield-custom-card',
  styles: [
    `
      .activeTAB {
        text-align: left;
        font-size: 14px;
        letter-spacing: 0.12px;
        color: #ffffff;
        opacity: 1;
        margin-left: 10px;
        white-space: nowrap;
      }
      .relates_to_topic_active {
        padding: 0 30px;
        margin-right: 10px;
        height: 45px;
        background: #007382;
        box-shadow: 0px 0px 18px #00000045;
        border-radius: 30px;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .relates_to_topic {
        width: 45px;
        height: 45px;
        background: #d6eaeb;
        opacity: 1;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
      }
      .highLightCss {
        color: red;
        font-size: 20px;
      }
      .tab_main_div {
        display: flex;
        align-items: center;
        justify-content: left;
        flex-wrap: nowrap;
        overflow-x: auto;
        height: 70px;
      }
      .tabCard {
        margin: 10px;
        padding: 10px;
      }
      .disabled-card {
        opacity: 0.3;
        pointer-events: none; /* prevent click/interaction */
      }
    `,
  ],
  template: ` <div class="">
    <ion-card
      class="tabCard ion-no-margin"
      [class.disabled-card]="isDisbaleFields"
    >
      <div class="tab_main_div" #scrollContainer>
        <div
          *ngFor="let tab of tabs"
          (click)="!isDisbaleFields && selectTab(tab)"
        >
          <div *ngIf="!tab.active" class="relates_to_topic">
            <img [src]="tab.in_active_img" />
          </div>
          <div *ngIf="tab.active" class="relates_to_topic_active">
            <img [src]="tab.active_img" />
            <div class="activeTAB">{{ tab.label }}</div>
          </div>
        </div>
      </div>
      <cvpc-haz-relates-to [options]="selected_tab.options"> </cvpc-haz-relates-to>
    </ion-card>
  </div>`,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ShieldCustomCardType extends FieldWrapper {
  isNativeDevice: boolean = true;
  tabs: any = [];
  selected_tab: any;
  editObs: any;
  isDisbaleFields: boolean = false;

  constructor(
    private lhStorage: LhStorageService,
    private bogService: BogTourService,
    public appConstants: AppConstants,
    private appService: AppService
  ) {
    super();
    // console.log("this.appConstants.relates_to_tab=",this.appConstants.relates_to_tab);

    this.isNativeDevice = Capacitor.isNativePlatform() ? true : false;
    this.bogService.relatesToSubject.subscribe((res) => {
      if (this.formControl != undefined) {
        this.formControl.patchValue({});
        this.formControl.markAsTouched();
      }
    });
    this.tabs = this.appConstants.relates_to_tab;
    this.selected_tab = this.tabs[0];
    this.checkSelectedTabs();
  }
  async checkSelectedTabs() {
    this.editObs = await this.lhStorage.get("editObservation");
    if (this.editObs) {
      console.log("in Edit observation");
      this.isDisbaleFields = true;
      const relatesTo = this.editObs.currentObservationInfo.relatesTo;
      // console.log("relatesTo=",relatesTo);
      // console.log("observation=",this.editObs.currentObservationInfo);
      if (Array.isArray(relatesTo) && relatesTo.length > 0) {
        let hazCategory = relatesTo[0]?.haz_category?.toLowerCase();

        // Special fallback when only one item and no haz_category
        if (!hazCategory && relatesTo.length === 1) {
          const type = relatesTo[0]?.type?.toLowerCase();
          if (type === 'industrial' || type === 'facility') {
            hazCategory = 'housekeeping';
          }
        }

        // 🔁 Step 1: Check if any item is 'health'
        const hasHealth = relatesTo.some((item) => item?.haz_category?.toLowerCase() === 'health');
        if (hasHealth) {
          this.activateTabByLabel("health");
          return; // ⛔ Stop further execution, health takes priority
        }

        // 🔁 Step 2: Fallback to first item's haz_category (if valid)
        if (['safety', 'environment', 'housekeeping'].includes(hazCategory)) {
          this.activateTabByLabel(hazCategory);
        } else {
          this.setFirstTabActive(); // fallback
        }
      } else {
        this.setFirstTabActive(); // fallback
      }
    } else {
      this.isDisbaleFields = false;
      console.log("in Fresh observation");
    }
  }

  activateTabByLabel(label: string) {
    const lowerLabel = label.toLowerCase();
    this.tabs.forEach((tab) => {
      tab.active = tab.label.toLowerCase() === lowerLabel;
      if (tab.active) {
        this.selected_tab = tab;

        const relatesToIds =
          this.editObs?.currentObservationInfo?.relatesTo?.map((item) => item.id) || [];
        if (Array.isArray(tab.options)) {
          tab.options.forEach((opt) => {
            if (relatesToIds.includes(opt.id)) {
              opt.card_checked = true;
              opt.checked = 'checked';
            } else {
              opt.card_checked = false;
              opt.checked = '';
            }
          });
        }
      }
    });

    console.log('Tabs after selection:', this.selected_tab);
  }

  private setFirstTabActive() {
    this.tabs.forEach((tab, i) => (tab.active = i === 0));
    this.selected_tab = this.tabs[0];
  }

  selectTab(tab: any) {
    this.tabs.forEach((tab) => (tab.active = false));
    tab.active = true;
    console.log('tab tab ::::', tab);
    this.selected_tab = tab;
  }
}
